import printComponent from './print.component';

let printLocationModule = angular.module('printLocation', [
])
    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/branchManagement.locations');

        $stateProvider
            .state('printLocation', {
                url: '/print-location',
                component: 'printLocation',
                data: {
                    requireLogin: true,
                    requireACL: 'branch_mgmt_locations.all'
                },
            })
    })

    .component('printLocation', printComponent)

    .name;

export default printLocationModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/locations/print/index.js